var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        path {\n            fill: #857ceb;\n        }\n        @media (prefers-color-scheme: dark) {\n            path {\n                fill: white;\n            }\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H22.5C24.99 2.49 27.51 5.01 30 7.5V15C29.55 14.55 15.45 0.45 15 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.90735e-06 0H7.5C7.56 0.06 30 22.5 30 22.5V30C28.77 28.74 1.23 1.23 -1.90735e-06 0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30H15C9.99 24.99 5.01 20.01 0 15V7.5C1.14 8.64 21.36 28.86 22.5 30Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 30H-4.76837e-07V22.5C0.0299997 22.53 7.47 29.97 7.5 30Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.76837e-07 7.5H7.5V15H-4.76837e-07V7.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15H15V22.5H7.5V15Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5H22.5V30H15V22.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H22.5V15H15V7.5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.76837e-07 22.5H7.5V30H-4.76837e-07V22.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0H15V7.5H7.5V0Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H30V7.5H22.5V0Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15H30V22.5H22.5V15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.b0a8742d23df4a56146149acea18deaf.svg";
export { ForwardRef as ReactComponent };